export const renderColors = {
  default: {
    text: 'text-utility-info-base',
    buttonProps: {
      type: 'info',
    },
    background: 'bg-brand-primary-base',
  },
  success: {
    text: 'text-utility-success-base',
    buttonProps: {
      type: 'success',
    },
    background: 'bg-utility-success-base',
  },
  warning: {
    text: 'text-utility-warning-base',
    buttonProps: {
      type: 'warning',
    },
    background: 'bg-utility-warning-base',
  },
  danger: {
    text: 'text-utility-danger-base',
    buttonProps: {
      type: 'danger',
    },
    background: 'bg-utility-danger-base',
  },
  info: {
    text: 'text-utility-info-base',
    buttonProps: {
      type: 'info',
    },
    background: 'bg-utility-info-base',
  },
};
